module.exports = __webpack_public_path__ + "static/media/expert@2x.2888fc9a.png";